import * as util from 'util';
import _ from 'lodash';
import {RouteService} from "../../../../../services/routeService";
import {NotificationService} from "../../../../../services/notificationService";
import {GeneralService} from "../../../../../services/generalService";
import {DICTIONARY} from "../../../../../dictionary";
import {Component, OnInit} from "@angular/core";
import {DomSanitizer} from "@angular/platform-browser";


@Component({
	selector: 'threat-prevention-component',
	templateUrl: './threat-prevention-rules.component.html',
})
export class ThreatPreventionComponent implements OnInit {
    constructor(public gs:GeneralService,
				private sanitizer:DomSanitizer,
				private rs:RouteService,
				private ns:NotificationService) {
    }

    dic = DICTIONARY;
    corpname = this.gs.corpname;
    enforceKeepRecord: string = '';
	_=_;
    reviewerActions = [
        this.dic.CONSTANTS.reviewerActions.setAsPrimary,
        this.dic.CONSTANTS.reviewerActions.assignGroups,
        this.dic.CONSTANTS.inboundConfigurationsActions.remove
    ];

	summernoteConfig = {
        height: 100,
        toolbar: [
            ['style', ['bold', 'italic', 'underline']],
            ['fontsize', ['fontsize']],
            ['view', ['codeview']]
        ],
        codemirror: {
            theme: 'monokai'
        },
        placeholder: 'HTML/text'
    };

    rulesMainActions = {
        release: 'Release',
        quarantine: 'Quarantine'
    };
    rulesSubActions = {
		keepRecord: DICTIONARY.CONSTANTS.tpRule.action.keepRecord,
		notifyReviewer: DICTIONARY.CONSTANTS.tpRule.action.notifyReviewer,
		addWarningLabel: DICTIONARY.CONSTANTS.tpRule.action.addWarningLabel,
		allowReviewerViewContent: DICTIONARY.CONSTANTS.tpRule.action.allowReviewerViewContent,
		addSubjectText: DICTIONARY.CONSTANTS.tpRule.action.addSubjectText,
		notifyRecipient: DICTIONARY.CONSTANTS.tpRule.action.notifyRecipient,
		releaseToFolder: DICTIONARY.CONSTANTS.tpRule.action.releaseToFolder,
		recipientControl: DICTIONARY.CONSTANTS.tpRule.action.recipientControl
	};
	// CC: the server and DB still use the original "Release to folder" action name - it is translated to/from the "Move to folder" display name on load/save
	releaseToFolderServerValue = 'Release to folder';
	isMailServerConnected = true;

    hexInputError;
    userInfo;
    config;
    modifyWarningLabelPopup;
    modifySubjectPopup;
	modifyFolderPopup;
    notifyOptionsPopup;
    excludeDomainsEmailsPopup;
    addExcludedEmailActive;
    newCustomizedFooterStr;
    retentionPeriodPopup;
	deleteQuarantinedEmailRecPopup;
	selectedRulePreset;
	mainRulePreset;
	rulePresets = [];
	addSubRulePopup;
	recipientPermissionsPopup;
	getThreatPreventionRulesInProcess;
	userReportRecipientModel;
	userReportRecipientsActionInProcess;

	expandedRuleType = null;
	subActionsDescriptions = {
		recipientControl: 'Recipient can act on this email directly',
		addWarningLabel: 'Insert a banner into the email body',
		allowReviewerViewContent: 'Reviewers can preview quarantined content',
		addSubjectText: 'Prefix the subject line, e.g. [EXTERNAL]',
		notifyReviewer: 'Send an alert to assigned reviewers',
		notifyRecipient: 'Let the recipient know an action was taken',
		keepRecord: 'Email records will be preserved',
		releaseToFolder: 'Route released mail to a specific folder'
	};

	ruleTypesTooltips = {
		[this.dic.CONSTANTS.tpRule.name.malicious]: "<b style='text-transform: capitalize;'>Malicious</b> - Indicates that this email has been sent to you for malicious purposes and/or contains malicious content that may harm you such as phishing, spear-phishing, ransomware, spoofing, viruses, or a zero-day attack",
		[this.dic.CONSTANTS.tpRule.name.suspicious]: "<b style='text-transform: capitalize;'>Suspicious</b> - Indicates that this email is suspected of being incorrectly configured/registered, or that its information/content has not been properly verified (certificate issues, DNS issues, etc.). This kind of email is not necessarily malicious",
		[this.dic.CONSTANTS.tpRule.name.spam]: "<b style='text-transform: capitalize;'>Spam</b> - The sender and/or the message has been classified as spam",
		[this.dic.CONSTANTS.tpRule.name.graymail]: "<b style='text-transform: capitalize;'>Graymail</b> - Marketing emails or newsletter that may be useful for some, but could be considered spam by others",
		[this.dic.CONSTANTS.tpRule.name.external]: "<b style='text-transform: capitalize;'>External</b> - Emails that originate from outside of your organization or trusted network",
	}

	ngOnInit() {
        this.getThreatPreventionRules();
		this.getMailServerConnectionStatus();

        this.gs.getUserInfo(false,  (userInfo) => {
            this.userInfo = userInfo;
        });
    };

	// CC: taken from inbound-mailboxes.component.ts -> ngOnInit (getInboundPlanSettings). mirrors the server's isExchangeServerConnected/isGsuiteServerConnected checks (utilityService.js) which gate the "Move to folder" action on save and on execution
	getMailServerConnectionStatus = () => {
		this.rs.getInboundPlanSettings().then((planInfo) => {
			this.isMailServerConnected = !!((planInfo.exchange_server?.tid && planInfo.exchange_server?.enabled) ||
				(planInfo.gsuite_server?.enabled && planInfo.gsuite_server?.admin_email && planInfo.gsuite_server?.customer_id));
		}, (err) => {
		});
	};

    getThreatPreventionRules = () => {
		this.getThreatPreventionRulesInProcess = true;

        this.rs.getTPRules().then( (response) => {
            this.config = response.config;
			this.getThreatPreventionRulesInProcess = false;
			this.rulePresets = [
				{
					name: this.dic.CONSTANTS.lfMainCustomizationName,
					...response.config.threat_protection.rules
				},
				...response.config.threat_protection.sub_rules
			];
			_.forEach(this.rulePresets, (rulePreset) => {
				this.translateRuleActionsFromServer(rulePreset);
			});
			this.selectedRulePreset = _.find(this.rulePresets, {name: this.selectedRulePreset?.name || ''}) || this.rulePresets[0];
			this.mainRulePreset = _.find(this.rulePresets, {name: this.dic.CONSTANTS.lfMainCustomizationName})

			if (this.config.threat_protection.security_awareness?.smart_banner?.enabled && this.config.threat_protection.security_awareness?.smart_banner?.allow_reporting) {
				this.enforceKeepRecord = 'Quarantine records will be kept for all external/non-safe emails since "Allow reporting" is enabled for smart banners';
			}
			else if (this.config.threat_protection.third_party_report?.microsoft?.mailbox) {
				this.enforceKeepRecord = 'Quarantine records will be kept for all emails since "Report from third-party client" is configured';
			}

			this.checkEnforceKeepRecord(this.rulePresets);

			}, (err) => {
			this.getThreatPreventionRulesInProcess = false;
		});
    }

	openAddSubRulePopup = () => {
		this.addSubRulePopup = {
			name: '',
			error: false,
			addSubRuleInProcess: false,
			show: true
		}
	}

	openCloneSubRulePopup = () => {
		this.addSubRulePopup = {
			name: '',
			sourcePreset: this.selectedRulePreset,
			error: false,
			addSubRuleInProcess: false,
			show: true
		};
	}

	addSubRule = () => {
		if (!this.addSubRulePopup.name) {
			this.addSubRulePopup.error = true;
			this.ns.showErrorMessage(util.format(DICTIONARY.ERRORS.emptyField, 'Name'));
			return;
		}

		if (_.map(this.rulePresets, 'name').includes(this.addSubRulePopup.name)) {
			this.addSubRulePopup.error = true;
			this.ns.showErrorMessage(util.format(DICTIONARY.ERRORS.XAlreadyExistInX, '"' + this.addSubRulePopup.name + '"', 'rules presets'));
			return;
		}

		const ruleData = {
			type: this.dic.CONSTANTS.rulesTpAction.subRules,
			action: this.addSubRulePopup.sourcePreset ? this.dic.CONSTANTS.actions.clone : this.dic.CONSTANTS.actions.add,
			name: this.addSubRulePopup.name,
		};

		if (this.addSubRulePopup.sourcePreset && this.addSubRulePopup.sourcePreset.name !== this.dic.CONSTANTS.lfMainCustomizationName) {
			ruleData['sourceName'] = this.addSubRulePopup.sourcePreset.name;
		}

		this.addSubRulePopup.addSubRuleInProcess = true;

		this.rs.updateTpRules('', ruleData).then((response) => {
			this.ns.showInfoMessage(this.dic.MESSAGES.changedSuccessfully);

			this.translateRuleActionsFromServer(response.sub_rule);
			this.rulePresets.push(response.sub_rule);
			const newRuleObjInList = _.find(this.rulePresets, {name: this.addSubRulePopup.name});
			this.selectedRulePreset = newRuleObjInList;
			this.addSubRulePopup = null;

			this.checkEnforceKeepRecord([newRuleObjInList]);
		}, (err) => {
			this.addSubRulePopup.addSubRuleInProcess = false;
		});
	}

	// CC: replaces the original "Release to folder" action name coming from the server with the "Move to folder" display name (see releaseToFolderServerValue)
	translateRuleActionsFromServer = (rulePreset) => {
		if (!rulePreset) {
			return;
		}
		_.forEach(_.values(this.dic.CONSTANTS.tpRule.name), (ruleType) => {
			if (rulePreset[ruleType]?.actions) {
				rulePreset[ruleType].actions = rulePreset[ruleType].actions.map((action) => {
					return action === this.releaseToFolderServerValue ? this.dic.CONSTANTS.tpRule.action.releaseToFolder : action;
				});
			}
		});
	};

	// force add keep record to all rules if: 1. this.enforceKeepRecord. OR 2. it's "malicious" rule type. OR 3. the main action is quarantined.
    checkEnforceKeepRecord = (rulesToCheck) => {
		rulesToCheck.forEach(rulesObj => {
			Object.keys(this.dic.CONSTANTS.tpRule.name).forEach(ruleType => {
				if (this.enforceKeepRecord || ruleType === this.dic.CONSTANTS.tpRule.name.malicious || rulesObj[ruleType].actions.includes(this.rulesMainActions.quarantine)) {
					_.union(rulesObj[ruleType].actions, [this.rulesSubActions.keepRecord]);
				}
			});
		});
	};

    hexInputChanged =  () => {
        // validate hex code and if is valid - refresh preview
        const reg = /^(0[xX])?[A-Fa-f0-9]+$/i;
        if (reg.test(this.modifyWarningLabelPopup.color.replace("#",'')) && this.modifyWarningLabelPopup.color.replace("#",'').length === 6) {
            this.hexInputError = false;
        }
        else {
            this.hexInputError = true;
        }
    }

    resetInboundRules = () => {
        this.gs.showPopup({
            title: 'Reset Threat Prevention Rules',
            subTitle: `You are about to reset threat prevention rules to default settings`,
            type: this.dic.CONSTANTS.popupWarning,
            doneBtnText: 'Reset',
            doneCb: () =>{
                const ruleData = {
                    type: this.dic.CONSTANTS.rulesTpAction.resetRules,
                };

				if (this.selectedRulePreset.name !== this.dic.CONSTANTS.lfMainCustomizationName) {
					ruleData['name'] = this.selectedRulePreset.name;
				}
                this.rs.updateTpRules(null, ruleData).then( (response) => {
                    this.getThreatPreventionRules();
                }, err => {
                });
            }
        });
    };

    monitorInboundRules = () => {
        this.gs.showPopup({
            title: 'Threat Prevention Monitor Mode',
            subTitle: `You are about to set the threat prevention rules on "Monitor mode"`,
            body: ['All threat types will be set to "Release" and a record will be kept for all non-internal emails'],
            type: this.dic.CONSTANTS.popupWarning,
            doneBtnText: 'Apply',
            doneCb: () =>{
                const ruleData = {
                    type: this.dic.CONSTANTS.rulesTpAction.monitorRules
                };

				if (this.selectedRulePreset.name !== this.dic.CONSTANTS.lfMainCustomizationName) {
					ruleData['name'] = this.selectedRulePreset.name;
				}
                this.rs.updateTpRules(null, ruleData).then( (response) => {
                    this.getThreatPreventionRules();
                }, err => {
                });
            }
        });
    };

	deleteSubRule = () => {
		this.gs.showPopup({
			title: 'Delete Custom Threat Prevention Rules Preset\n',
			subTitle: ` You are about to delete the custom Threat Prevention Rules Preset: "${this.selectedRulePreset.name}"`,
			body: [],
			type: this.dic.CONSTANTS.popupWarning,
			doneBtnText: 'Delete',
			doneCb: () =>{
				const ruleData = {
					type: this.dic.CONSTANTS.rulesTpAction.subRules,
					action: this.dic.CONSTANTS.actions.delete,
					name: this.selectedRulePreset.name
				};

				this.rs.updateTpRules(null, ruleData).then( (response) => {
					_.remove(this.rulePresets, {name: this.selectedRulePreset.name});
					this.selectedRulePreset = this.rulePresets[0];
				}, err => {
				});
			}
		});
	}

	forceLogicOnRuleMainActions = (actionsArr, actionClicked) => {
		switch (actionClicked) {
			case this.rulesMainActions.release:
				actionsArr = _.without(actionsArr, this.rulesMainActions.quarantine);
				break;

			case this.rulesMainActions.quarantine:
				actionsArr = _.without(actionsArr, this.rulesMainActions.release);
				actionsArr = _.without(actionsArr, this.rulesSubActions.recipientControl);
				actionsArr = _.without(actionsArr, this.rulesSubActions.releaseToFolder); // "Move to folder" only applies to released emails
				actionsArr = _.union(actionsArr, [this.rulesSubActions.keepRecord]); // (_.union => add if not already exists)
				break;
		}

		return actionsArr;
	}

	showRulePrimaryActionsPopup = (ruleType, actionClicked) => {
		let actionsDataArr = _.clone(this.selectedRulePreset[ruleType].actions);

		if (_.values(this.rulesMainActions).includes(actionClicked)) {
			if (actionsDataArr.includes(actionClicked)) {
				return;
			}
		}

		let body = [];
		if (this.gs.controlAdmin?.email && this.gs.controlAdmin.email !== this.gs.userInfo.email) {
			body.push(`Action applied for ${this.gs.controlAdmin?.display_email}`);
		}
		this.gs.showPopup({
			title: 'Update Action',
			subTitle: `You are about to change the primary action for the threat type "${ruleType[0].toUpperCase() + ruleType.slice(1)}" to "${actionClicked}".`,
			body: body,
			type: this.dic.CONSTANTS.popupWarning,
			doneBtnText: 'Update',
			doneCb: () => {
				this.updateRulesActions(ruleType, actionClicked);
			}
		});
	};

	selectRulesAction = (ruleType, actionClicked) => {
		if (actionClicked === this.rulesSubActions.releaseToFolder && !this.selectedRulePreset[ruleType].actions.includes(this.rulesSubActions.releaseToFolder) && !this.selectedRulePreset[ruleType].options?.release_folder) {
			this.openModifyFolder(ruleType, true);
			return;
		}
		this.updateRulesActions(ruleType, actionClicked);
	};

	// update rules main actions and secondary actions
    updateRulesActions = (ruleType, actionClicked) => {
		let originalActionsDataArr = _.clone(this.selectedRulePreset[ruleType].actions);
		let actionsDataArr = _.clone(this.selectedRulePreset[ruleType].actions);

		// main action clicked
		if (_.values(this.rulesMainActions).includes(actionClicked)) { //Todo - remove this part in the second update when we change the functionality for the secondary actions
			if (actionsDataArr.includes(actionClicked)) {
				return;
			}

			actionsDataArr = this.forceLogicOnRuleMainActions(actionsDataArr, actionClicked);
		}

		actionsDataArr = this.gs.toggleItemInArray(actionsDataArr, actionClicked);

		this.selectedRulePreset[ruleType].actions = actionsDataArr;

        const ruleData = {
            type: this.dic.CONSTANTS.rulesTpAction.rule,
            action: 'actions',
            ruleName: ruleType,
            data: {
				// CC: translate the "Move to folder" display name back to the original action name used by the server
                actions: actionsDataArr.map((action) => {
					return action === this.dic.CONSTANTS.tpRule.action.releaseToFolder ? this.releaseToFolderServerValue : action;
				})
            }
        };

		if (this.selectedRulePreset.name !== this.dic.CONSTANTS.lfMainCustomizationName) {
			ruleData['name'] = this.selectedRulePreset.name;
		}

        return this.rs.updateTpRules(null, ruleData).then( (response) => {
            if (ruleType === this.dic.CONSTANTS.tpRule.name.external && actionClicked === this.rulesMainActions.quarantine &&
				actionsDataArr.includes(this.rulesMainActions.quarantine)) {
                this.ns.showWarnMessage(this.dic.ERRORS.ruleExternalNoReleaseIgnore);
            }

            if (ruleType === this.dic.CONSTANTS.tpRule.name.malicious && actionClicked === this.rulesMainActions.release &&
				actionsDataArr.includes(this.rulesMainActions.release)) {
                this.ns.showWarnMessage(this.dic.ERRORS.ruleMaliciousRelease);
            }

			if (ruleType === this.dic.CONSTANTS.tpRule.name.malicious && actionClicked === this.rulesSubActions.recipientControl &&
				actionsDataArr.includes(this.rulesSubActions.recipientControl) && this.selectedRulePreset.malicious.options?.recipient_release_email) {
				this.ns.showWarnMessage(this.dic.ERRORS.ruleMaliciousAllowRecipientControl);
			}

            if (ruleType !== this.dic.CONSTANTS.tpRule.name.malicious && actionClicked === this.rulesSubActions.keepRecord &&
                !actionsDataArr.includes(this.rulesSubActions.keepRecord)) {

				this.deleteQuarantinedEmailRecPopup = {
					show: true,
					applyInProcess: false,
					subTitle: `Do you also want to delete all quarantined email records of type: ${ruleType}?`,
					verifyEmail: '',
					doneCb: () =>{
						this.deleteQuarantinedEmailRecPopup.applyInProcess = true;
						this.rs.deleteQuarantinedEmail(ruleType, {email: this.deleteQuarantinedEmailRecPopup.verifyEmail}).then( () => {
							this.ns.showInfoMessage('Quarantined emails were deleted successfully');
							this.deleteQuarantinedEmailRecPopup = null;
						}, (err) => {
							this.deleteQuarantinedEmailRecPopup.applyInProcess = false;
						})
					}
				};
            }

        }, err => {
			this.selectedRulePreset[ruleType].actions = originalActionsDataArr;
        });
    };

    getColorAndHeaderByType = (ruleType) => {
        if (!ruleType) return;

        let isCustomColor = false;
        let borderColor = '#ff8c00';
        let backgroundColor = '#ff8c00';
        let header;
        switch (ruleType) {
            case this.dic.CONSTANTS.tpRule.name.malicious:
                header = this.dic.CONSTANTS.emailScannedMaliciousHeader;
                borderColor = '#8b0000';
                backgroundColor = '#f08080';
                break;

            case this.dic.CONSTANTS.tpRule.name.suspicious:
                header = this.dic.CONSTANTS.emailScannedSuspiciousHeader;
                break;

            case this.dic.CONSTANTS.tpRule.name.spam:
                header = this.dic.CONSTANTS.emailScannedSpamHeader;
                break;

            case this.dic.CONSTANTS.tpRule.name.graymail:
                header = this.dic.CONSTANTS.emailScannedGraymailHeader;
                break;

            case this.dic.CONSTANTS.tpRule.name.external:
                header = this.dic.CONSTANTS.emailScannedExternalHeader;
                break;
        }

        if (this.selectedRulePreset[ruleType].options && this.selectedRulePreset[ruleType].options.warning_color) {
            backgroundColor = this.selectedRulePreset[ruleType].options && this.selectedRulePreset[ruleType].options.warning_color;
            borderColor = backgroundColor;
        }
        header = this.selectedRulePreset[ruleType].options && this.selectedRulePreset[ruleType].options.warning_text || header;
        return {header, borderColor, backgroundColor, isCustomColor};
    };

    openModifyWarning = (ruleType) => {
        if (!ruleType) return;
		const options = this.getColorAndHeaderByType(ruleType);

		this.modifyWarningLabelPopup = {
			ruleType,
			color: options.backgroundColor,
			text: options.header,
			sanitizedText: this.sanitizer.bypassSecurityTrustHtml(options.header) || options.header,
			report_safe: this.selectedRulePreset[ruleType].options?.report_safe,
			report_malicious: this.selectedRulePreset[ruleType].options?.report_malicious,
			modifyWarningInProcess: false,
			show: true
		};
    };

	openRecipientPermissionsPopup = (ruleType) => {
		this.recipientPermissionsPopup = {
			show: true,
			threat_analysis: true,
			ruleType
		};
	}

	updateRecipientPermissions = (permissionType) => {
		const ruleType = this.recipientPermissionsPopup.ruleType;
		const ruleData = {
			type: this.dic.CONSTANTS.rulesTpAction.rule,
			action: 'recipient',
			ruleName: ruleType,
			data: {
				type: permissionType,
				enabled: this.selectedRulePreset[ruleType].options[permissionType],
			}
		};

		if (this.selectedRulePreset.name !== this.dic.CONSTANTS.lfMainCustomizationName) {
			ruleData['name'] = this.selectedRulePreset.name;
		}

		this.rs.updateTpRules(null, ruleData).then( (response) => {

		}, err => {
		});
	};

	warningLabelTextChanged = () => {
		let rawText = this.modifyWarningLabelPopup.text?.trim();

		if (rawText === '<br>' || rawText === '<br/>' || rawText === '<br />' || rawText === '<p><br></p>' || rawText === '<p><br/></p>' || rawText === '<p><br /></p>') {
			rawText = '';
		}

		if (rawText) {
			this.modifyWarningLabelPopup.sanitizedText = this.sanitizer.bypassSecurityTrustHtml(rawText);
		} else {
			rawText = this.getDefaultWarningLabelText(this.modifyWarningLabelPopup.ruleType);
			this.modifyWarningLabelPopup.text = '';
			this.modifyWarningLabelPopup.sanitizedText = rawText;
		}
	};

	getDefaultWarningLabelText(ruleType) {
		let text = '';
		switch (ruleType) {
			case this.dic.CONSTANTS.tpRule.name.malicious:
				text = this.dic.CONSTANTS.emailScannedMaliciousHeader;
				break;

			case this.dic.CONSTANTS.tpRule.name.suspicious:
				text = this.dic.CONSTANTS.emailScannedSuspiciousHeader;
				break;

			case this.dic.CONSTANTS.tpRule.name.spam:
				text = this.dic.CONSTANTS.emailScannedSpamHeader;
				break;

			case this.dic.CONSTANTS.tpRule.name.graymail:
				text = this.dic.CONSTANTS.emailScannedGraymailHeader;
				break;

			case this.dic.CONSTANTS.tpRule.name.external:
				text = this.dic.CONSTANTS.emailScannedExternalHeader;
				break;
		}
		return text;
	}

	openModifySubject = (ruleType) => {
        if (!ruleType) return;

        this.modifySubjectPopup = {
            ruleType,
            text: (this.selectedRulePreset[ruleType].options && this.selectedRulePreset[ruleType].options.subject_text) || '',
			modifySubjectInProcess: false,
            show: true
        }
    };

	openModifyFolder = (ruleType, isPendingActionToggle=false) => {
		if (!ruleType) {
			return;
		}

		this.modifyFolderPopup = {
			ruleType,
			text: (this.selectedRulePreset[ruleType].options && this.selectedRulePreset[ruleType].options.release_folder) || '',
			isPendingActionToggle: isPendingActionToggle,
			modifyFolderInProcess: false,
			show: true
		};
	};

	resetWarningLabel = () => {
		this.gs.showPopup({
			title: 'Reset Warning Label',
			subTitle: `You are about to reset the warning label to its default settings`,
			type: this.dic.CONSTANTS.popupInfo,
			doneBtnText: 'Reset',
			doneCb: () => {
				this.modifyWarning(true);
			}
		});
	}

    modifyWarning = (isReset) => {
        if (this.hexInputError) {
            this.ns.showWarnMessage('Please fix color input');
            return;
        }

        if ((!isReset && (!this.modifyWarningLabelPopup.text || !this.modifyWarningLabelPopup.color)) ||
            !this.modifyWarningLabelPopup.ruleType || this.modifyWarningLabelPopup.modifyWarningInProcess) {
            return;
        }

		const color = isReset ? '' : '#' + this.modifyWarningLabelPopup.color.replace('#','');
		const text = isReset ? '' : this.modifyWarningLabelPopup.text;
		const reportMalicious = isReset ? false : (this.modifyWarningLabelPopup.report_malicious || false);
		const reportSafe = isReset ? false : (this.modifyWarningLabelPopup.report_safe || false);

		const ruleData = {
            type: this.dic.CONSTANTS.rulesTpAction.rule,
            action: 'options',
            ruleName: this.modifyWarningLabelPopup.ruleType,
            data: {
                options: {
                    label_type: 'warning',
                    warning_color: color,
                    warning_text: text,
					report_malicious: reportMalicious,
					report_safe: reportSafe
				}
            }
        };

		if (this.selectedRulePreset.name !== this.dic.CONSTANTS.lfMainCustomizationName) {
			ruleData['name'] = this.selectedRulePreset.name;
		}

        this.modifyWarningLabelPopup.modifyWarningInProcess = true;

        this.rs.updateTpRules('', ruleData).then( (response) => {
            this.selectedRulePreset[this.modifyWarningLabelPopup.ruleType].options.warning_color = color;
            this.selectedRulePreset[this.modifyWarningLabelPopup.ruleType].options.warning_text = text;
            this.selectedRulePreset[this.modifyWarningLabelPopup.ruleType].options.report_safe = reportSafe;
			this.selectedRulePreset[this.modifyWarningLabelPopup.ruleType].options.report_malicious = reportMalicious;

			if (reportSafe || reportMalicious) {
                if (!this.selectedRulePreset[this.modifyWarningLabelPopup.ruleType].actions.includes(this.dic.CONSTANTS.tpRule.action.keepRecord)) {
                    this.selectedRulePreset[this.modifyWarningLabelPopup.ruleType].actions.push(this.dic.CONSTANTS.tpRule.action.keepRecord);
                }
            }

			this.openModifyWarning(this.modifyWarningLabelPopup.ruleType);
			if (!isReset) {
				this.modifyWarningLabelPopup = null;
			}

        }, err => {
            this.modifyWarningLabelPopup.modifyWarningInProcess = false;
        });
    };

    modifySubject = () => {
        if (this.modifySubjectPopup.modifySubjectInProcess) {
            return
        }

        const ruleData = {
            type: this.dic.CONSTANTS.rulesTpAction.rule,
            action: 'options',
            ruleName: this.modifySubjectPopup.ruleType,
            data: {
                options: {
                    label_type: 'subject',
                    subject_text: this.modifySubjectPopup.text
                }
            }
        };

		if (this.selectedRulePreset.name !== this.dic.CONSTANTS.lfMainCustomizationName) {
			ruleData['name'] = this.selectedRulePreset.name;
		}

        this.modifySubjectPopup.modifySubjectInProcess = true;

        this.rs.updateTpRules('', ruleData).then( (response) => {
            this.selectedRulePreset[this.modifySubjectPopup.ruleType].options.subject_text = this.modifySubjectPopup.text;
            this.modifySubjectPopup = null;
        }, err => {
            this.modifySubjectPopup.modifySubjectInProcess = false;
        });
    };

	modifyFolder = () => {
		if (this.modifyFolderPopup.modifyFolderInProcess) {
			return;
		}

		if (!this.modifyFolderPopup.text?.trim()) {
			this.ns.showWarnMessage(util.format(this.dic.ERRORS.cannotBeEmpty, 'Folder name'));
			return;
		}

		const ruleData = {
			type: this.dic.CONSTANTS.rulesTpAction.rule,
			action: 'options',
			ruleName: this.modifyFolderPopup.ruleType,
			data: {
				options: {
					label_type: 'folder',
					release_folder: this.modifyFolderPopup.text
				}
			}
		};

		if (this.selectedRulePreset.name !== this.dic.CONSTANTS.lfMainCustomizationName) {
			ruleData['name'] = this.selectedRulePreset.name;
		}

		this.modifyFolderPopup.modifyFolderInProcess = true;

		if (this.modifyFolderPopup.isPendingActionToggle) {
			this.updateRulesActions(this.modifyFolderPopup.ruleType, this.rulesSubActions.releaseToFolder).then(() => {
				this.rs.updateTpRules('', ruleData).then(() => {
					this.selectedRulePreset[this.modifyFolderPopup.ruleType].options.release_folder = this.modifyFolderPopup.text;
					this.modifyFolderPopup = null;
				}, () => {
					this.modifyFolderPopup.modifyFolderInProcess = false;
				});
			}, () => {
				this.modifyFolderPopup.modifyFolderInProcess = false;
			});
			return;
		}

		this.rs.updateTpRules('', ruleData).then( (response) => {
			this.selectedRulePreset[this.modifyFolderPopup.ruleType].options.release_folder = this.modifyFolderPopup.text;
			this.modifyFolderPopup = null;
		}, err => {
			this.modifyFolderPopup.modifyFolderInProcess = false;
		});
	};

	updateAutoReleaseMaliciousUrlsDefangStatus = () => {
		const tpData = {
			type: this.dic.CONSTANTS.rulesTpAction.autoReleaseMaliciousUrlsDefang,
			enabled: this.config.threat_protection.auto_release_malicious_urls_defang.enabled,
			only_for_known_contacts: this.config.threat_protection.auto_release_malicious_urls_defang.only_for_known_contacts,
		};

		this.rs.updateTpRules('', tpData).then(() => {
		});
	};

    // CC: logic moved to notification-options-component
    openNotifyOptions = () => {
        this.notifyOptionsPopup = {show: true};
    };

    openExcludeDomainsEmailsPopup = () => {
		const excludeDomainsEmails = (this.mainRulePreset.skip_add_warning_banner || []).map(itm => ({value:itm}));
        this.excludeDomainsEmailsPopup = {
            emails: _.cloneDeep(excludeDomainsEmails),
            emailsBefore: excludeDomainsEmails,
            show: true,
        }

    };

    startAddExcludedEmail =  () => {
        if (this.addExcludedEmailActive) {
            return;
        }

        this.addExcludedEmailActive = true;

        const newEmail = {
            isEditMode: true,
            isNew: true,
            edit: {
                value: '',
            }
        };

        this.excludeDomainsEmailsPopup.emails.unshift(newEmail);
    };

    confirmAddExcludedEmail =  (email ,isApproved) => {
        // new email/domain process was declined
        if (!isApproved) {
            _.remove<any>(this.excludeDomainsEmailsPopup.emails, email);
            this.addExcludedEmailActive = false;
            return;
        }
        //

        // new email/domain approved
        if (!email.edit.value) {
            return this.ns.showErrorMessage(util.format(this.dic.ERRORS.accountEmailMissingName, 'Email/Domain field'));
        }
        if (!this.gs.validateEmail(email.edit.value) && !this.gs.isValidDomain(email.edit.value)) {
            return this.ns.showErrorMessage(util.format(this.dic.ERRORS.invalidDomainOrAddress, email.edit.value));
        }
        if (_.find(this.excludeDomainsEmailsPopup.emails, e => {return !e.isNew && e.value && e.value === email.edit.value.toLowerCase()})) {
            return this.ns.showErrorMessage(util.format(this.dic.ERRORS.emailDomainAlreadyExist, email.edit.value));
        }

        email.value = email.edit.value.toLowerCase();

        email.edit = null;
        email.isEditMode = false;
        email.isNew = undefined; // keep it 'undefined' and not 'false' for sticking the item to the top of the table only when in edit
        this.addExcludedEmailActive = false;
    };

    searchExcludedEmail =  (searchTerm, activeFilters) => {
        this.excludeDomainsEmailsPopup.emails.forEach(record => {
            // search
            if (searchTerm) {
                const isFound = record.value && record.value.toLowerCase().includes(searchTerm.toLowerCase());
                if (!isFound) {
                    record.hide = true;
                    return;
                }
            }

            record.hide = false;
        });
    };

    showExcludedEmailActions = () => {
        return [
            this.dic.CONSTANTS.inboundConfigurationsActions.remove
        ]
    }

    selectExcludedEmailAction = (emailOrDomain, action) => {
        switch (action) {
            case this.dic.CONSTANTS.inboundConfigurationsActions.remove:
                _.remove<any>(this.excludeDomainsEmailsPopup.emails, emailOrDomain);
                break;
        }
    };

    changeExcludeDomainsEmails = () => {
		if (this.addExcludedEmailActive) {
            _.remove<any>(this.excludeDomainsEmailsPopup.emails, email => {return email.isNew});
            this.addExcludedEmailActive = false;
        }
        const emailsInCurrentList = _.map(this.excludeDomainsEmailsPopup.emails, 'value');

        const ruleData = {
            type: this.dic.CONSTANTS.rulesTpAction.rule,
            action: 'options',
            data: {
                options: {
                    skip_add_warning_banner: emailsInCurrentList
                }
            }
        };

        this.excludeDomainsEmailsPopup.changeExcludeDomainsEmailsInProcess = true;

        this.rs.updateTpRules('', ruleData).then( (response) => {
			this.mainRulePreset.skip_add_warning_banner = emailsInCurrentList;

            this.excludeDomainsEmailsPopup.changeExcludeDomainsEmailsInProcess = false;
            this.excludeDomainsEmailsPopup = null;
        });
    };

    updateFooterStatus = () => {
        const tpData = {
            type: this.dic.CONSTANTS.rulesTpAction.footer,
            action: 'status',
            enabled: this.config.threat_protection.add_footer,
        };

        this.rs.updateTpRules('', tpData).then(() => {});
    };

	updateImpersonationSuspicious(modelKey) {
		const tpData = {
			type: this.dic.CONSTANTS.rulesTpAction.impersonation,
			key: modelKey,
			enabled: this.mainRulePreset[modelKey]
		};

		this.rs.updateTpRules('', tpData).then(() => {});
	}

	updateSendUserReportsToReviewers = () => {
		const tpData = {
			type: this.dic.CONSTANTS.rulesTpAction.userReportsReviewers,
			enabled: this.mainRulePreset.send_user_reports_to_reviewers,
			skip_safe_send_user_reports_to_reviewers: this.mainRulePreset.skip_safe_send_user_reports_to_reviewers,
		};

		this.rs.updateTpRules('', tpData).then(() => {});
	};

	updateUserReportNotificationRecipients = (action, recipient=null) => {
		let tpData;
		const email = _.trim(this.userReportRecipientModel || '').toLowerCase();

		switch (action) {
			case this.dic.CONSTANTS.actions.add:
				if (!this.gs.validateEmail(email)) {
					this.ns.showWarnMessage(this.dic.ERRORS.accountEmailInvalid);
					return;
				}
				if (this.mainRulePreset.user_report_notification_emails?.includes(email)) {
					this.ns.showWarnMessage(util.format(DICTIONARY.ERRORS.emailAlreadyExist, email));
					return;
				}

				tpData = {
					type: this.dic.CONSTANTS.rulesTpAction.userReportNotificationRecipients,
					action: this.dic.CONSTANTS.actions.add,
					email: email
				};
				break;

			case this.dic.CONSTANTS.actions.delete:
				tpData = {
					type: this.dic.CONSTANTS.rulesTpAction.userReportNotificationRecipients,
					action: this.dic.CONSTANTS.actions.delete,
					email: recipient
				};
				break;
		}

		this.userReportRecipientsActionInProcess = true;
		this.rs.updateTpRules('', tpData).then(() => {
			if (action === this.dic.CONSTANTS.actions.add) {
				if (!this.mainRulePreset.user_report_notification_emails) {
					this.mainRulePreset.user_report_notification_emails = [];
				}
				this.mainRulePreset.user_report_notification_emails.push(email);
				this.userReportRecipientModel = '';
			}
			else {
				_.remove(this.mainRulePreset.user_report_notification_emails, recipientToDelete => recipient === recipientToDelete);
			}
			this.userReportRecipientsActionInProcess = false;
		}, err => {
			this.userReportRecipientsActionInProcess = false;
		});
	};

    updateFooterContent = () => {
        if (!this.config.threat_protection.add_footer) {
            return;
        }

        const tpData = {
            type: this.dic.CONSTANTS.rulesTpAction.footer,
            action: 'customization',
            customization_footer: this.newCustomizedFooterStr,
        };

        this.rs.updateTpRules('', tpData).then(() => {
            this.config.threat_protection.customization_footer = this.newCustomizedFooterStr;
        });
    };

    openRetentionPeriodPopup = (ruleType) => {
        this.retentionPeriodPopup = {
            type: ruleType,
            newRetentionPeriod: this.mainRulePreset[ruleType].retention_period,
            show: true,
			retentionPeriodInProcess: false,
            error: ''
        }
    }

    changeRetentionPeriod = (period) => {
        if (!period || period < 1 || period > 180) {
            this.ns.showErrorMessage(this.dic.ERRORS.retentionPeriodRange);
            return;
        }

        const ruleData = {
            type: this.dic.CONSTANTS.rulesTpAction.rule,
            action: 'retentionPeriod',
            ruleName: this.retentionPeriodPopup.type,
            data: {
                period: period
            }
        };

		this.retentionPeriodPopup.retentionPeriodInProcess = true;

        this.rs.updateTpRules('', ruleData).then( (response) => {
            this.mainRulePreset[this.retentionPeriodPopup.type].retention_period = period;
			this.retentionPeriodPopup.retentionPeriodInProcess = false;
			this.retentionPeriodPopup.show = false;
        }, (err) => {
            this.ns.showErrorMessage(err.data.message);
			this.retentionPeriodPopup.retentionPeriodInProcess = false;

		});
    };
}

